import React, { useContext } from "react";
import { IdentifierMappingContext } from "../IdentifierMappingContext";
import { useFetch } from "../../Hooks/useFetch";
import { FetchBoundary } from "../../common/FetchBoundary";
import { formatMappingRequestStatus, formatPharmacyGroupName } from "../../utils/Helpers";
import { humanizeText } from "../../utils/StringFormatters";

export const MappingRequestTab = ({ pharmacyGroupDetails }) => {
  const { coveredEntity340bId } = useContext(IdentifierMappingContext);

  const mappingRequestFetcher = useFetch(
    `/api/covered_entities/${coveredEntity340bId}/pharmacy_groups/${encodeURIComponent(pharmacyGroupDetails.name)}/mapping_requests`
  );

  const mappingRequests = mappingRequestFetcher.data?.mapping_requests ?? [];

  return (
    <div className="mt-4">
      <div className="t--500 mb-2">Mapping Requests</div>
      <div className="t--secondary t--sm">
        View all mapping requests for identifiers related to this group.
      </div>

      <FetchBoundary {...mappingRequestFetcher} className="mt-3">
        <div className="container-fluid row-border-rounded" style={{ minWidth: 700 }}>
          <div className="row align-items-center py-3 bg--neutrals-gray-3 t--sm border--rounded-top">
            <div className="col t--500 col-2">Identifier</div>
            <div className="col t--500">Status</div>
            <div className="col t--500">Previous Group</div>
            <div className="col t--500">New Group</div>
            <div className="col t--500 col-2">Request Date</div>
          </div>
          {mappingRequests.map((mr) => (
            <div
              key={mr.identifier_type + mr.identifier + mr.created_at}
              className="row align-items-center t--sm py-3 row-border-bottom"
            >
              <div className="col col-2">
                <div className="flex flex-shrink-0 align-items-center gap--4">
                  <div>{mr.identifier}</div>
                  <div
                    className={`badge px-2 py-1 border--none shadow-none t--navyblue bg--light-gray border--rounded`}
                  >
                    {mr.identifier_type.toUpperCase()}
                  </div>
                </div>
              </div>
              <div className="col">{formatMappingRequestStatus(mr.status)}</div>
              <div className="col">
                {mr.original_group_name ? formatPharmacyGroupName(mr.original_group_name) : "N/A"}
              </div>
              <div className="col">{formatPharmacyGroupName(mr.group_name)}</div>
              <div className="col col-2">
                <div className="pb-1">
                  {new Date(mr.created_at).toLocaleString([], {
                    dateStyle: "short",
                    timeStyle: "short",
                  })}
                </div>
                {mr.submitter_name}
              </div>
            </div>
          ))}
        </div>
      </FetchBoundary>
    </div>
  );
};
